import { render, staticRenderFns } from "./ChangeShop.vue?vue&type=template&id=77a6f6c3&scoped=true"
import script from "./ChangeShop.vue?vue&type=script&lang=js"
export * from "./ChangeShop.vue?vue&type=script&lang=js"
import style0 from "./ChangeShop.vue?vue&type=style&index=0&id=77a6f6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a6f6c3",
  null
  
)

export default component.exports